
export default {
  name: "cal-swipeable",
  props: {
    length: {
      type: Number,
      required: true,
      default: 0,
    },
    sm: {
      type: Number,
      default: 1,
    },
    md: {
      type: Number,
      default: 1,
    },
    lg: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 0,
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    hideButtons: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeSlide: 0,
      startPosition: 0,
      currentPosition: 0,
      position: 0,
      windowWidth: window.innerWidth,
      isDragging: false,
      lastTouchTime: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.setWindowWidth);
    this.setWindowWidth();
  },
  destroyed() {
    window.removeEventListener("resize", this.setWindowWidth);
  },
  computed: {
    visibleItemCount() {
      if (this.windowWidth < 768) {
        this.$emit("visibilityChange", this.sm);
        return this.sm;
      } else if (this.windowWidth < 1024) {
        this.$emit("visibilityChange", this.md);
        return this.md;
      } else {
        this.$emit("visibilityChange", this.lg);
        return this.lg;
      }
    },
    numSlides() {
      return Math.ceil(this.length / this.visibleItemCount);
    },
  },
  watch: {
    value(newValue) {
      this.changeActiveSlide(newValue);
    },
  },
  methods: {
    handleTouchStart(event) {
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
      this.isDragging = true;
      this.startTime = Date.now();
      this.startTranslate = this.position;
    },
    handleTouchMove(event) {
      if (!this.isDragging) return;
      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;
      const diffX = currentX - this.startX;
      const diffY = currentY - this.startY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        // Horizontal movement - prevent default to stop vertical scrolling
        event.preventDefault();
        this.position = this.startTranslate + diffX;
      } else {
        // Vertical movement - allow default scrolling
        this.isDragging = false;
        this.changeActiveSlide(this.activeSlide);
      }
    },
    handleTouchEnd(event) {
      if (!this.isDragging) return;
      this.isDragging = false;
      const endX = event.changedTouches[0].clientX;
      const diffX = endX - this.startX;
      const duration = Date.now() - this.startTime;

      const velocity = Math.abs(diffX) / duration;
      const shouldChangePage = Math.abs(diffX) > this.itemWidth() / 3 || velocity > 0.15;

      if (shouldChangePage) {
        if (diffX > 0 && this.activeSlide > 0) {
          this.changeActiveSlide(this.activeSlide - 1);
        } else if (diffX < 0 && this.activeSlide < this.numSlides - 1) {
          this.changeActiveSlide(this.activeSlide + 1);
        } else {
          this.changeActiveSlide(this.activeSlide);
        }
      } else {
        this.changeActiveSlide(this.activeSlide);
      }
    },
    changeActiveSlide(index) {
      if (index < 0) index = 0;
      if (index >= this.numSlides) index = this.numSlides - 1;
      this.activeSlide = index;
      this.position = index * this.visibleItemCount * this.itemWidth() * -1;
      this.$emit("input", this.activeSlide);
    },
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.changeActiveSlide(this.activeSlide);
    },
    itemWidth() {
      return this.$refs.swipeContainer.offsetWidth / this.visibleItemCount;
    },
  },
};
